import { mount } from 'svelte';
import { Sfx } from './audio/sounds';
import { installDeviceDiagnostics } from './platform/device-diagnostics';
import { createBrowserStore } from './platform/storage';
import { installDiagnostics } from './platform/telemetry';
import { Appearance } from './themes/appearance.svelte';
import QueryApp from './QueryApp.svelte';
import './style.css';

// One storage facade and one appearance store for the app's lifetime.
const store = createBrowserStore();
const appearance = new Appearance(store);

installDiagnostics();
installDeviceDiagnostics(() => ({
  theme: appearance.theme.id,
  preferences: {
    effects: appearance.effects,
    music: appearance.music,
    ambience: appearance.ambience,
    animations: appearance.animations,
  },
  audio: Sfx.diagnosticsSnapshot(),
}));

const target = document.getElementById('root');
if (!target) throw new Error('Spellie mount point is missing');
export default mount(QueryApp, { target, props: { store, appearance } });
